import { render, staticRenderFns } from "./AddMemberModal.vue?vue&type=template&id=085e2b90&scoped=true"
import script from "./AddMemberModal.vue?vue&type=script&lang=js"
export * from "./AddMemberModal.vue?vue&type=script&lang=js"
import style0 from "./AddMemberModal.vue?vue&type=style&index=0&id=085e2b90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085e2b90",
  null
  
)

export default component.exports